(function () {
  'use strict';

  function initUGC(section) {
    var viewport = section.querySelector('.rz-ugc__viewport');
    var track = section.querySelector('.rz-ugc__track');
    if (!viewport || !track) return;

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var autoTimer = null;
    var halfWidth = 0;

    function measure() {
      halfWidth = track.scrollWidth / 2;
    }
    measure();
    window.addEventListener('resize', measure);

    function loopIfNeeded() {
      if (viewport.scrollLeft >= halfWidth) {
        viewport.scrollLeft -= halfWidth;
      } else if (viewport.scrollLeft <= 0) {
        viewport.scrollLeft += halfWidth;
      }
    }

    function startAuto() {
      stopAuto();
      autoTimer = setInterval(function () {
        if (isDown) return;
        viewport.scrollLeft += 0.6;
        loopIfNeeded();
      }, 16);
    }

    function stopAuto() {
      clearInterval(autoTimer);
    }

    /* Drag manual (mouse + touch vía Pointer Events) */
    viewport.addEventListener('pointerdown', function (e) {
      isDown = true;
      viewport.classList.add('is-dragging');
      startX = e.clientX;
      startScroll = viewport.scrollLeft;
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var walk = startX - e.clientX;
      viewport.scrollLeft = startScroll + walk;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      viewport.classList.remove('is-dragging');
      loopIfNeeded();
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointerleave', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    /* Loop también mientras se hace scroll manual (rueda del mouse, trackpad) */
    viewport.addEventListener('scroll', loopIfNeeded, { passive: true });

    startAuto();
  }

  function init() {
    document.querySelectorAll('.rz-ugc').forEach(initUGC);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.rz-ugc');
    if (section) initUGC(section);
  });
})();